<template>
	<!-- Layout inner -->
  <div class="layout-inner">
    <!-- Layout navbar -->
    <navbar></navbar>
    <!-- / Layout navbar -->
    <div class="layout-container">
      <div class="layout-content">

        <div class="hd_bar">
          <div class="hd_ic ic-course"></div>
          <div class="hd_txt">
            <v-clamp class="title_txt" autoresize :max-lines="2" id="courseTitle">{{ course.title }}</v-clamp>

            <b-popover ref="courseTitlePopupContainer" target="courseTitle" triggers="click" placement="top" class="title_popup" container="courseTitleContainer">
              <div class="title_container">
                {{ course.title }}
              </div>
              <div class="ic_container">
                <span class="ic ic-close" v-on:click="hideCourseTitlePopup"></span>
              </div>
            </b-popover>
            <div id="courseTitleContainer" class="title_container_popup"></div>

          </div>
        </div>

        <div class="row sub_hd_bar resource">
          <div class="col-12">
            <div class="sub_hd_ic">
              <span v-if="entity.fileType === 'assessment'" class="ic ic-assessment"></span>
              <span v-if="entity.fileType === 'video'" class="ic ic-video"></span>
              <span v-if="entity.fileType === 'pdf'" class="ic ic-file-pdf"></span>
              <span v-if="entity.fileType === 'doc' || entity.fileType === 'docx'" class="ic ic-file-word"></span>
              <span v-if="entity.fileType === 'xlsx'" class="ic ic-file-excel"></span>
              <span v-if="entity.fileType === 'html'" class="ic ic-pageURL"></span>
              <span v-if="entity.fileType === 'externalurl'" class="ic ic-pageURL"></span>
              <span v-if="entity.fileType === 'other'" class="ic ic-pageURL"></span>
              <span v-if="entity.fileType === 'jpg' || entity.fileType === 'jpeg' || entity.fileType === 'png' || entity.fileType === 'gif'" class="ic ic-image"></span>
            </div>
            <div class="sub_hd_txt_lg">
              <v-clamp class="title_txt" autoresize :max-lines="2" id="entityTitle">{{ entity.title }}</v-clamp>

              <b-popover ref="entityTitlePopupContainer" target="entityTitle" triggers="click" placement="top" class="title_popup" container="entityTitleContainer">
                <div class="title_container">
                  {{ entity.title }}
                </div>
                <div class="ic_container">
                  <span class="ic ic-close" v-on:click="hideEntityTitlePopup"></span>
                </div>
              </b-popover>
              <div id="entityTitleContainer" class="title_container_popup"></div>

            </div>
          </div>
        </div>


        <!-- Page content -->
        <div class="container-fluid flex-grow-1">
          <div :style="styles.renderingArea" class="section pad-sml assessment_container">
            <assessment-launch :entity-uuid="entityUuid" :course-uuid="uuid" :session-id="sessionId"></assessment-launch>
          </div>
        </div>
      </div>
    </div>
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Navbar from '../../misc/components/./Navbar'
import AssessmentLaunch from '../../assessment/components/AssessmentLaunch'
import VClamp from 'vue-clamp'

export default {
  name: 'assessment-learn',
  props: ['uuid', 'entityUuid', 'sessionId'],
  components: {
    Navbar,
    AssessmentLaunch,
    VClamp
  },
  data () {
    return {
      styles: {
        renderingArea: {
          background: '#f0f0f0',
          margin: '1rem 0'
        }
      }
    }
  },

  mounted () {
    this.loadDetail()
  },

  methods: {
    ...mapActions([
      'loadCourseDetail',
      'loadEntityDetail'
    ]),
    async loadDetail () {
      await this.loadCourseDetail(this.uuid)
      let entityDetailInfo = {
        'entityType': this.entityType,
        'entityUuid': this.entityUuid
      }
      await this.loadEntityDetail(entityDetailInfo)
    },
    hideCourseTitlePopup () {
      this.$refs.courseTitlePopupContainer.$emit('close')
    },
    hideEntityTitlePopup () {
      this.$refs.entityTitlePopupContainer.$emit('close')
    }
  },

  computed: {
    ...mapState({
      'course': state => state.dashboard.course,
      'entity': state => state.dashboard.entity
    })
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/app/assessment/components/AssessmentLearn.vue